export let CartService = {
    clearCart: () => {
        localStorage.removeItem("cart")
    }
}